import type { CampaignGroup } from '../models';
import type { CreativeAdItem } from 'lib.store/src/type-partner/creatives/models';

export const getAdsFromGroups = (groups?: CampaignGroup[]): CreativeAdItem[] => {
  if (!groups?.length) return [];
  return groups.flatMap((group) => group.ads ?? []);
};
